import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';

import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { FC } from 'react';
import gtm from '@/utils/gtm';

interface NavProps {
    theme?: 'black' | 'white';
}
const Nav: FC<NavProps> = (props) => {
    const { theme = 'black' } = props;
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();

    const { t } = useLang('SHP40');

    const dataA: EcoNavProductProps = {
        tabItems: [
            {
                value: '/ocean-smart-electrical-panel-40',
                label: t(`nav_product`),
                href: '/ocean-smart-electrical-panel-40',
            },
            {
                value: '/ocean-smart-electrical-panel-40/support',
                label: t(`nav_support`),
                href: `/ocean-smart-electrical-panel-40/support`,
            },
            {
                value: '/ocean-smart-electrical-panel-40/specs',
                label: t(`nav_specs`),
                href: `/ocean-smart-electrical-panel-40/specs`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t(`nav_consultation`),
                href: `https://www.ecoflow.com/us/ocean-pro-consultation`,
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'product_navigation',
                    navigation_name: t(`nav_consultation`),
                    product_name: t(`nav_logo_text`),
                },
            },
        ],
    };

    return (
        <section className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'logo',
                        label: t(`nav_logo_text`),
                        href: '/ocean-pro-home-solar-battery',
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={router?.pathname || ''}
                theme={theme}
                onBuyChange={(item) => {
                    gtm.push(item.dataLayer);
                }}
            />
        </section>
    );
};

export default Nav;
